import {
  AnimatedModal,
  EHeadingStyleVariant,
  EModalSize,
  EModalVariants,
  ETextStyleVariant,
  Heading,
  Modal,
  Text,
} from '@outdoorsyco/bonfire';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useBreakpointContext } from '@/components/common/BreakpointContext';

import { CurrencySelector } from './CurrencySelector';
import { LanguageSelector } from './LanguageSelector';

type TLanguageAndCurrencyModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const LanguageAndCurrencyModal = ({ isOpen, onClose }: TLanguageAndCurrencyModalProps) => {
  const { isAboveDesktop } = useBreakpointContext();

  const content = <LanguageCurrencyContent onClose={onClose} />;

  if (isAboveDesktop) {
    return (
      <Modal isOpen={isOpen} onClose={onClose} size={EModalSize.Medium} withOverlay isDismissable>
        {content}
      </Modal>
    );
  }

  return (
    <AnimatedModal
      isOpen={isOpen}
      onClose={onClose}
      variant={EModalVariants.Bottom}
      withOverlay
      isDismissable>
      {content}
    </AnimatedModal>
  );
};

type TLanguageCurrencyContentProps = {
  onClose: () => void;
};

const LanguageCurrencyContent = ({ onClose }: TLanguageCurrencyContentProps) => (
  <>
    <Modal.Actions />

    <Modal.Header>
      <Heading component="div" variant={EHeadingStyleVariant.H6}>
        <FormattedMessage
          id="4dU8A6"
          defaultMessage="Language & currency"
          description="GlobalHeader > Language & currency modal > Title"
        />
      </Heading>
    </Modal.Header>

    <Modal.Content>
      <div className="flex flex-col pt-2 pb-4 gap-6">
        <div className="flex flex-col gap-2">
          <Text variant={ETextStyleVariant.MediumBold}>
            <FormattedMessage
              id="gacd9J"
              defaultMessage="Currency"
              description="GlobalHeader > Language & currency modal > Currency label"
            />
          </Text>
          <CurrencySelector onSelect={onClose} />
        </div>

        <div className="flex flex-col gap-2">
          <Text variant={ETextStyleVariant.MediumBold}>
            <FormattedMessage
              id="p6dOHg"
              defaultMessage="Language"
              description="GlobalHeader > Language & currency modal > Language label"
            />
          </Text>
          <LanguageSelector onSelect={onClose} />
        </div>
      </div>
    </Modal.Content>
  </>
);
